// const DEFAULT_HYPHEN_LENGTH = 20
// const SOFT_HYPHEN = '&shy;'

const CleanHashtagsFilter = {
  name: 'cleanHash',
  fn: (value: any, _hyphenLength?: number) : string => {
    if (!value) return ''

    // make sure hashtags have at least one space between
    // eg '#ABC#DEF' becomes ' #ABC #DEF'
    const hashTagRE = /(#[^ #]*)/gi
    const spacesRE = /\s{2,}/
    return value.replace(hashTagRE, ' $1').replace(spacesRE,' ')
  }
}

export default CleanHashtagsFilter
